import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeRemapIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M8.16002 8.15999L5.99002 5.98999C7.21002 4.76999 8.77002 3.92999 10.52 3.61999C12.76 3.22999 15.01 3.72999 16.87 5.02999C18.73 6.32999 19.97 8.27999 20.37 10.52C20.46 11.07 21 11.43 21.53 11.33C22.07 11.23 22.44 10.72 22.34 10.17C21.85 7.40999 20.32 4.99999 18.02 3.38999C15.72 1.77999 12.94 1.15999 10.17 1.64999C8.00002 2.02999 6.07002 3.05999 4.57002 4.56999L2.39002 2.38999L1.13002 8.68999C1.04002 9.11999 1.42002 9.48999 1.85002 9.40999L8.15002 8.14999L8.16002 8.15999Z"
        fill={color}
      />
      <path
        d="M22.86 15.3C22.95 14.87 22.57 14.5 22.14 14.58L15.84 15.84L18.01 18.01C16.8 19.23 15.23 20.07 13.48 20.38C8.86001 21.19 4.44002 18.1 3.63002 13.48C3.53002 12.94 3.02002 12.57 2.47002 12.67C1.93002 12.77 1.56002 13.28 1.66002 13.83C2.56002 18.92 7.00002 22.51 12 22.51C12.6 22.51 13.21 22.46 13.83 22.35C16 21.97 17.93 20.94 19.43 19.43L21.61 21.61L22.87 15.31L22.86 15.3Z"
        fill={color}
      />
      <path
        d="M10.8 16.2H13.2C13.53 16.2 13.8 15.93 13.8 15.6V12.75H15.6C16.01 12.75 16.35 12.41 16.35 12C16.35 11.59 16.01 11.25 15.6 11.25H13.8V8.4C13.8 8.07 13.53 7.8 13.2 7.8H10.8C10.47 7.8 10.2 8.07 10.2 8.4V11.25H8.40002C7.99002 11.25 7.65002 11.59 7.65002 12C7.65002 12.41 7.99002 12.75 8.40002 12.75H10.2V15.6C10.2 15.93 10.47 16.2 10.8 16.2Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeRemapIcon.displayName = 'TimeRemapIcon';
